import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";

import PageHead from "../Head";
import Contact from "@/components/Contacts/Contact";
import ContactFormPhp from "@/components/Contacts/Contact-Form-php";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import FooterOne from "@/components/Footer/Footer-One";

const ContactPage = () => {
  return (
    <>
      <PageHead title="Contacto - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />

          <div className="rbt-conatct-area bg-gradient-11 rbt-section-gap">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title text-center mb--60">
                    <span className="subtitle bg-secondary-opacity">
                      Contact Us
                    </span>
                    <h2 className="title">
                      Estamos listos <br /> para resolver tus dudas
                    </h2>
                  </div>
                </div>
              </div>
              <Contact />
            </div>
          </div>
          <ContactFormPhp />
          <div className="rbt-google-map bg-color-white rbt-section-gapTop">
            <iframe
              className="w-100"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15899.03080222067!2d-75.6086459!3d4.9798837!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e477c088680fdd5%3A0xeb6fcece048fe336!2sCentro%20Educativo%20Menfis!5e0!3m2!1ses-419!2sco!4v1714736419974!5m2!1ses-419!2sco"
              height="600"
              style={{ border: "0" }}
            ></iframe>
          </div>

          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default ContactPage;
